import { render, staticRenderFns } from "./DemoDatepickerReadonlyAndDisabled.vue?vue&type=template&id=189c6965&"
import script from "./DemoDatepickerReadonlyAndDisabled.vue?vue&type=script&lang=js&"
export * from "./DemoDatepickerReadonlyAndDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDatePicker,VRow})
